import React, {useEffect, useState} from 'react';
import {Button} from "antd";
import dayjs from "dayjs";
import {useTranslations} from "../../lang";
import api from "../../api";

export default function AccountIos() {

    const [plan, setPlan] = useState(false)
    const [company, setCompany] = useState(false)
    const {translate} = useTranslations()

    useEffect(() => {
        api.get_plan().then(setPlan)
        api.getMyCompany().then(setCompany)
    }, []);

    function sendMessage(message) {
        window.webkit.messageHandlers.iosJsMessageHandler.postMessage(
            JSON.stringify(message)
        );
    }


    return (
        <div style={{padding: '20px', textAlign: 'center', background: 'white'}}>
            <h1>Oogst.app</h1>
            <h2>{plan?.name}</h2>
            {(company.plan_expires_at && (
                <p className={"mar-t-1"}>

                    {translate('Je account verloopt op')}:<br/>
                    {dayjs(company.plan_expires_at).format("dddd D MMMM YYYY")}
                </p>
            ))}
            <p>Wil je een jaar extra toegang? Klik dan op de onderstaande button om een extra jaar toe te voegen.</p>
            <Button onClick={() => {
                sendMessage({
                    "action": "do-payment",
                    "jwt": localStorage.getItem('token')
                })
            }} type={"primary"}>Voeg 1 jaar toe</Button>
        </div>
    )
}